import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class WikipediaScannerService {

  public url = 'v1';

  constructor(public http: HttpClient,
              private authenticationService: AuthenticationService) { }

  getScannerStatus(): Observable<{ status: boolean}> {
      return this.http.get<{ status: boolean}>(this.url + '/wikipedia/scanner-status?v=' + new Date().getTime());
  }

  getParserStatus(): Observable<{ status: string, concurrent: number, parserQueueDepth: number}> {
      return this.http.get<{ status: string, concurrent: number, parserQueueDepth: number}>(this.url + '/wikipedia/parser-status?v=' + new Date().getTime());
  }

  updateScannerStatus(v: boolean): Observable<void> {
    return this.http.post<void>(this.url + '/wikipedia/scanner-status', {enabled: v});
  }

  updateParserStatus(v: boolean): Observable<void> {
    return this.http.post<void>(this.url + '/wikipedia/parser-status', {enabled: v});
  }

  updateParserConcurrency(v: number): Observable<string> {
    return this.http.post<string>(this.url + '/wikipedia/parser-concurrency', {newValue: v});
  }

}
